import { PayloadAction, createSlice } from "@reduxjs/toolkit";

import { Game } from "@/types";

import { GameState } from "./type";

const initialState: GameState = {
  favorites: [],
  recent: [],
  gameCache: {},
};

const gameSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setFavorites: (state, action: PayloadAction<string[]>) => {
      state.favorites = action.payload;
    },
    addFavorite: (state, action: PayloadAction<string>) => {
      if (!state.favorites.some((id) => id === action.payload)) {
        state.favorites.push(action.payload);
      }
    },
    removeFavorite: (state, action: PayloadAction<string>) => {
      state.favorites = state.favorites.filter((id) => id !== action.payload);
    },
    addRecent: (state, action: PayloadAction<string>) => {
      state.recent = state.recent.filter((id) => id !== action.payload);
      state.recent.unshift(action.payload);
      if (state.recent.length > 10) {
        state.recent.pop();
      }
    },
    cacheGame: (state, action: PayloadAction<Game>) => {
      const game = action.payload;
      if (!game?.gid) return;
      if (!state.gameCache) state.gameCache = {};
      state.gameCache[game.gid] = game;
    },
    clearRecent: (state) => {
      state.recent = [];
    },
    clearFavorites: (state) => {
      state.favorites = [];
    },
  },
});

export default gameSlice.reducer;

export const {
  setFavorites,
  addFavorite,
  removeFavorite,
  addRecent,
  cacheGame,
  clearRecent,
  clearFavorites,
} = gameSlice.actions;
